import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import './card.sass'
import { noop } from '@src/util/noop'

@Component
export class Card extends Vue {

  @Prop({ required: false, default: noop })
  click: () => void

  render (h: CreateElement) {
    return <div class='card' onClick={this.click}>
      <div class='content'>
        <div class='left'>
          {this.$slots.header}
          <div class='body'>
            {this.$slots.preview}
            <div class='info'>
              {this.$slots.tooltips}
              {this.$slots.title}
              {this.$slots.specs}
            </div>
          </div>
        </div>
        {this.$slots.right}
      </div>
      {this.$slots.expanded}
    </div>
  }
}
